import {
  Dropdown,
  DropdownButton,
  DropdownDivider,
  DropdownHeading,
  DropdownItem,
  DropdownMenu,
  DropdownSection,
} from "V2.0/common/dropdown";
import { ChevronDownIcon, PlusIcon } from "@heroicons/react/16/solid";
import { CheckIcon, FolderIcon } from "@heroicons/react/24/outline";

export function WorkspaceSwitcher({
  loading,
  projects,
  user,
  activeProject,
  setActiveProject,
  setIsOpen,
}) {
  const handleClick = (index) => {
    setActiveProject(index);
  };

  const isUserOwner =
    user?.isOwner ?? user?.userAccessLevel === "WHITELABELOWNER";

  const isUserOperator = user?.userAccessLevel === "WHITELABELOPERATOR";

  const showCreateNew = isUserOwner || isUserOperator;

  return (
    <>
      <Dropdown>
        <DropdownButton
          outline
          loading={loading}
        >
          <FolderIcon />
          <p className="truncate max-w-56">
            {projects &&
              projects[activeProject] &&
              projects[activeProject].name}
          </p>
          <ChevronDownIcon />
        </DropdownButton>
        <DropdownMenu className="min-w-64">
          {showCreateNew && (
            <DropdownSection>
              <DropdownSection className="">
                <DropdownItem onClick={() => setIsOpen(true)}>
                  <PlusIcon /> Create new
                </DropdownItem>
              </DropdownSection>
            </DropdownSection>
          )}
          <DropdownDivider />
          <DropdownSection>
            <DropdownHeading>Workspaces</DropdownHeading>
            <DropdownSection className="max-h-80 overflow-scroll">
              {projects &&
                projects.map((project, index) => (
                  <DropdownItem
                    className=""
                    onClick={() => handleClick(index)}
                    key={index}
                  >
                    <div className="flex gap-x-4">
                      <p className="truncate max-w-40">{project.name}</p>
                      {project?._id === projects[activeProject]?._id && (
                        <CheckIcon width="16" />
                      )}
                    </div>
                  </DropdownItem>
                ))}
            </DropdownSection>
          </DropdownSection>
        </DropdownMenu>
      </Dropdown>
    </>
  );
}
